import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { getWebApiErrorMessage } from "@faire/web--source/common/getErrorMessage";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { useMutation as useInviteUserMutation } from "@faire/web-api--source/api/retailer/invitations/invite/post-hooks";
import { useMutation as useCheckUserAvailabilityMutation } from "@faire/web-api--source/api/user/availability/post-hooks";
import { trackUserInvitationDeactivationFlowInviteExistingAccountUserSubmit } from "@faire/web-api--source/events/userInvitation/submit/deactivationFlowInviteExistingAccountUser";
import { ICheckEmailAddressAndBusinessAvailabilityRequest } from "@faire/web-api--source/indigofair/data/ICheckEmailAddressAndBusinessAvailabilityRequest";
import { IInviteUserRequest } from "@faire/web-api--source/indigofair/data/IInviteUserRequest";
import { IRetailerAccountUserManagement } from "@faire/web-api--source/indigofair/retailer/IRetailerAccountUserManagement";
export var useInviteUser = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useCheckUserAvailabilityMutation = useCheckUserAvailabilityMutation(), checkUserAvailability = _useCheckUserAvailabilityMutation.mutateAsync;
    var _useInviteUserMutation = useInviteUserMutation(), inviteUser = _useInviteUserMutation.mutateAsync;
    var userToken = useUserStore([
        "userToken"
    ]).userToken;
    var handleInviteUser = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(emailAddress) {
            var error, accountUserToken, email, _userInviteResponse_retailer_user_account_user, _userInviteResponse_retailer_user, checkUserAvailabilityResponse, userInviteResponse, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        error = undefined;
                        accountUserToken = undefined;
                        email = emailAddress.trim();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            checkUserAvailability([
                                ICheckEmailAddressAndBusinessAvailabilityRequest.build({
                                    email_address: email
                                })
                            ])
                        ];
                    case 2:
                        checkUserAvailabilityResponse = _state.sent();
                        return [
                            4,
                            inviteUser([
                                IInviteUserRequest.build({
                                    email: email,
                                    invited_retailer_role: IRetailerAccountUserManagement.Role.CONTRIBUTOR,
                                    subscribe_to_emails: false
                                })
                            ])
                        ];
                    case 3:
                        userInviteResponse = _state.sent();
                        accountUserToken = userInviteResponse === null || userInviteResponse === void 0 ? void 0 : (_userInviteResponse_retailer_user = userInviteResponse.retailer_user) === null || _userInviteResponse_retailer_user === void 0 ? void 0 : (_userInviteResponse_retailer_user_account_user = _userInviteResponse_retailer_user.account_user) === null || _userInviteResponse_retailer_user_account_user === void 0 ? void 0 : _userInviteResponse_retailer_user_account_user.account_user_token;
                        if (accountUserToken && (checkUserAvailabilityResponse === null || checkUserAvailabilityResponse === void 0 ? void 0 : checkUserAvailabilityResponse.email_address_available) === false) {
                            trackUserInvitationDeactivationFlowInviteExistingAccountUserSubmit(userToken, accountUserToken);
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        e = _state.sent();
                        error = getWebApiErrorMessage(e, strictLocalize);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2,
                            {
                                accountUserToken: accountUserToken !== null && accountUserToken !== void 0 ? accountUserToken : "",
                                error: error
                            }
                        ];
                }
            });
        });
        return function handleInviteUser(emailAddress) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        handleInviteUser: handleInviteUser
    };
};
